import * as React from 'react'

export const useOnUpdate = (shouldUpdate, onUpdate) => {
  React.useEffect(() => {
    if (shouldUpdate()) {
      onUpdate()
    }
  }, [onUpdate, shouldUpdate])
}
